var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 183,
    viewBox: "0 0 215 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_496_49855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M212.233 175.093C209.337 173.366 208.086 168.904 209.667 165.957C211.276 162.96 216.22 161.614 219.174 163.375C222.202 165.178 223.354 170.021 221.455 172.949C219.621 175.784 215.137 176.825 212.233 175.093Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.8145 169.079C28.5516 166.013 32.8256 164.917 35.9062 166.761C38.8928 168.54 39.988 172.342 38.3828 175.407C36.7241 178.584 32.5589 179.853 29.4283 178.133C26.3106 176.41 25.0821 172.137 26.8145 169.079Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M217.782 72.3695C220.629 74.2765 221.565 78.3154 219.82 81.1679C217.998 84.152 213.538 85.2289 210.623 83.3817C207.632 81.4788 206.699 77.1678 208.635 74.1948C210.645 71.1114 214.689 70.2989 217.782 72.3695Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.2353 163.924C79.5058 167.148 75.4987 168.333 72.3036 166.554C69.1907 164.823 67.9752 160.546 69.7309 157.524C71.4012 154.65 75.4317 153.5 78.4288 155.033C81.6775 156.7 82.9541 160.738 81.2353 163.924Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.7793 169.917C58.0352 172.957 53.6656 174.086 50.6509 172.28C47.5374 170.416 46.5955 166.33 48.5462 163.18C50.3842 160.205 54.2422 159.164 57.2399 160.829C60.3116 162.537 61.5268 166.89 59.7793 169.917Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M110.156 100.707C113.217 102.453 114.322 106.731 112.5 109.792C110.697 112.82 106.989 113.848 103.871 112.202C100.654 110.498 99.3611 106.374 101.05 103.258C102.703 100.243 107.152 98.9952 110.156 100.707Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M202.532 53.1575C204.119 50.1041 208.533 48.8032 211.603 50.4767C214.541 52.0742 215.745 56.0483 214.237 59.1151C212.594 62.4546 208.689 63.786 205.411 62.1128C202.253 60.4978 200.905 56.298 202.532 53.1575Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M79.7928 109.058C81.6132 105.81 85.5762 104.721 88.758 106.58C91.8247 108.372 92.9317 112.685 91.0924 115.681C89.3658 118.5 85.2566 119.615 82.2984 118.072C79.1757 116.434 78.0104 112.24 79.7928 109.058Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M95.5665 81.7559C97.4527 78.5459 101.398 77.5445 104.566 79.4835C107.443 81.2433 108.543 85.2453 106.966 88.2057C105.341 91.2484 100.933 92.5199 97.8857 90.8265C94.8023 89.101 93.7231 84.8919 95.5665 81.7559Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M45.1316 150.877C41.9927 149.153 40.7664 144.914 42.5247 141.849C44.1833 138.957 48.215 137.787 51.2251 139.316C54.4668 140.957 55.76 145.005 54.0775 148.223C52.3869 151.436 48.3362 152.64 45.1316 150.877Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M82.9637 85.0079C86.0247 86.7532 87.1364 91.058 85.324 94.1022C83.5306 97.1135 79.7916 98.1571 76.6866 96.507C73.4617 94.7986 72.1642 90.6827 73.8662 87.5638C75.5289 84.5319 79.952 83.2911 82.9637 85.0079Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M66.5871 145.246C63.4362 143.581 62.2978 139.436 64.1027 136.234C65.8351 133.177 69.5782 131.993 72.6814 133.532C75.8139 135.078 77.212 139.361 75.616 142.487C74.052 145.575 69.7133 146.898 66.5871 145.246Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M116.822 39.5454C115.048 42.7323 110.986 43.8416 107.816 42.0003C104.848 40.2648 103.657 36.3638 105.183 33.3407C106.737 30.2682 111.122 28.8847 114.212 30.5041C117.289 32.127 118.539 36.4571 116.822 39.5454Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M89.7257 60.1131C91.5815 57.1268 96.0485 56.0758 98.9275 57.9464C101.897 59.8692 102.806 64.2214 100.868 67.1602C98.9442 70.0743 95.1518 70.9445 92.1098 69.1662C88.9726 67.344 87.8605 63.1158 89.7257 60.1131Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M204.214 108.217C202.488 111.245 198.051 112.434 195.089 110.669C192.069 108.871 191.018 104.557 192.863 101.531C194.675 98.5639 198.472 97.5535 201.549 99.2318C204.734 100.972 205.974 105.131 204.214 108.217Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M136.649 149.452C133.533 147.784 132.382 143.566 134.171 140.41C135.888 137.398 139.685 136.235 142.784 137.782C145.923 139.354 147.311 143.599 145.71 146.732C144.157 149.783 139.741 151.105 136.649 149.452Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M120.96 176.627C117.835 174.955 116.684 170.737 118.489 167.59C120.205 164.6 124.046 163.418 127.111 164.946C130.223 166.491 131.615 170.804 130.015 173.916C128.444 176.979 124.055 178.294 120.96 176.627Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M106.98 124.766C108.799 121.539 112.801 120.439 115.966 122.289C119.016 124.072 120.134 128.424 118.309 131.395C116.587 134.206 112.469 135.316 109.511 133.773C106.384 132.143 105.199 127.927 106.98 124.766Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M93.6396 160.865C90.5457 159.101 89.5042 154.902 91.3853 151.777C93.1856 148.792 97.0167 147.703 100.056 149.315C103.136 150.951 104.429 155.283 102.756 158.353C101.08 161.388 96.6842 162.601 93.6396 160.865Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M94.6465 128.064C97.6834 129.927 98.6246 134.166 96.6733 137.185C94.7634 140.151 91.0723 141.035 87.9831 139.263C84.82 137.448 83.6617 133.281 85.481 130.262C87.2991 127.265 91.6424 126.22 94.6465 128.064Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M130.783 127.74C127.698 125.903 126.592 121.646 128.451 118.673C130.193 115.884 134.343 114.792 137.245 116.358C140.344 118.038 141.508 122.252 139.737 125.375C137.913 128.61 133.997 129.639 130.783 127.74Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M155.488 98.0923C153.714 101.356 149.784 102.464 146.563 100.616C143.454 98.8209 142.288 94.5725 144.089 91.5659C145.769 88.752 149.932 87.5807 152.854 89.0922C155.967 90.6917 157.209 94.9405 155.488 98.0923Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M111.343 54.4114C113.29 51.2476 117.267 50.3629 120.388 52.3842C123.239 54.2275 124.244 58.2409 122.581 61.1408C120.869 64.1442 116.381 65.3258 113.445 63.554C110.436 61.7182 109.458 57.4682 111.343 54.4114Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M75.61 179.101C77.4252 175.938 81.5781 174.804 84.6328 176.655C87.638 178.478 88.7257 182.901 86.8785 185.815C85.1061 188.619 81.0171 189.68 78.0779 188.104C74.9283 186.417 73.7899 182.272 75.61 179.101Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M138.451 70.2373C140.324 67.0308 144.294 66.0436 147.453 67.9991C150.337 69.7848 151.447 73.7703 149.874 76.7225C148.271 79.7453 143.79 81.0294 140.782 79.3256C137.733 77.598 136.635 73.3451 138.451 70.2373Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M60.9309 123.644C57.7168 121.898 56.4699 117.79 58.2083 114.703C59.9229 111.657 64.2384 110.508 67.3146 112.284C70.2263 113.965 71.3644 117.901 69.8241 120.949C68.1556 124.218 64.1814 125.422 60.9309 123.644Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M154.108 43.1197C155.945 39.8812 159.861 38.8525 163.065 40.7682C165.982 42.5176 167.137 46.442 165.613 49.4439C164.064 52.4869 159.623 53.816 156.565 52.1602C153.487 50.4819 152.333 46.2512 154.108 43.1197Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M182.577 113.952C180.708 117.171 176.772 118.156 173.587 116.208C170.69 114.425 169.574 110.469 171.144 107.504C172.751 104.473 177.203 103.183 180.224 104.883C183.299 106.604 184.394 110.844 182.577 113.952Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M225.471 102.416C223.605 105.649 219.693 106.669 216.507 104.742C213.604 102.989 212.481 99.0069 214.062 96.0594C215.711 92.9756 220.065 91.6839 223.104 93.3725C226.204 95.1074 227.298 99.2708 225.471 102.416Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M115.039 154.895C111.963 153.042 110.906 148.758 112.775 145.823C114.658 142.886 119.05 141.945 121.977 143.865C124.81 145.72 125.719 149.655 124.005 152.625C122.148 155.841 118.247 156.823 115.039 154.895Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M177.898 46.228C174.831 44.4355 173.703 40.1213 175.517 37.1324C177.316 34.1683 181.8 33.1056 184.715 34.9528C187.527 36.73 188.517 40.7892 186.868 43.7411C185.07 46.9691 181.063 48.0775 177.898 46.228Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M183.753 67.8463C180.68 66.1598 179.524 61.8949 181.301 58.7975C183.055 55.7413 186.754 54.6527 189.874 56.257C193.074 57.8957 194.422 62.0189 192.803 65.1641C191.238 68.1976 186.794 69.5137 183.753 67.8463Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M136.316 25.346C139.084 27.2951 139.922 31.4089 138.131 34.1693C136.195 37.1423 131.78 38.1027 128.935 36.1746C125.962 34.1623 125.182 30.005 127.201 26.9818C129.258 23.9139 133.258 23.1967 136.316 25.346Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M65.3876 191.393C63.5407 194.516 59.4248 195.528 56.3351 193.624C53.3112 191.757 52.2785 187.41 54.1811 184.495C56.0231 181.665 59.9501 180.752 62.95 182.451C66.2131 184.302 67.2725 188.204 65.3876 191.393Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M177.125 128.789C179.003 125.651 183.1 124.671 186.205 126.606C189.059 128.386 190.151 132.46 188.556 135.356C186.88 138.391 182.457 139.632 179.45 137.907C176.402 136.158 175.305 131.828 177.125 128.789Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M166.873 141.152C165.004 144.371 161.099 145.341 157.901 143.396C154.999 141.622 153.882 137.687 155.456 134.714C157.055 131.678 161.454 130.423 164.514 132.113C167.587 133.799 168.694 138.036 166.873 141.152Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M189.614 89.2264C186.473 87.5443 185.193 83.3401 186.889 80.2507C188.547 77.227 193.013 75.9887 196.002 77.7255C198.876 79.3958 200.014 83.4085 198.463 86.4173C196.766 89.7365 192.884 90.9715 189.614 89.2264Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M204.275 144.486C206.121 141.384 210.283 140.387 213.372 142.292C216.24 144.068 217.338 148.113 215.733 151.025C214.056 154.081 209.667 155.32 206.647 153.598C203.636 151.881 202.487 147.489 204.275 144.486Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M209.747 129.671C207.856 132.889 203.951 133.859 200.779 131.907C197.874 130.12 196.784 126.157 198.39 123.224C200.059 120.162 204.441 118.898 207.444 120.61C210.502 122.342 211.572 126.568 209.747 129.671Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M188.442 171.93C190.128 168.78 194.29 167.575 197.431 169.333C200.523 171.063 201.703 175.364 199.934 178.389C198.275 181.226 194.165 182.417 191.195 180.933C188.134 179.396 186.793 175.013 188.442 171.93Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M182.725 150.337C184.435 147.299 188.8 146.102 191.814 147.853C194.836 149.608 195.87 153.858 194.018 156.933C192.194 159.96 188.526 160.957 185.427 159.277C182.257 157.568 180.996 153.407 182.725 150.337Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M161.388 156.047C163.223 152.906 167.342 151.851 170.441 153.739C173.446 155.562 174.505 159.979 172.641 162.884C170.849 165.665 166.688 166.718 163.813 165.124C160.758 163.426 159.609 159.11 161.388 156.047Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M148.077 192.284C145.019 190.573 143.899 186.264 145.708 183.206C147.45 180.264 151.368 179.138 154.373 180.697C157.459 182.303 158.794 186.638 157.147 189.701C155.522 192.744 151.128 193.991 148.077 192.284Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M165.631 85.9189C167.507 82.7466 171.519 81.7619 174.67 83.7126C177.546 85.4937 178.646 89.4956 177.065 92.4431C175.45 95.4481 170.953 96.7227 167.971 95.0119C164.918 93.2713 163.818 88.9843 165.631 85.9189Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M149.807 113.346C151.56 110.102 155.556 108.955 158.753 110.768C161.844 112.52 163.028 116.812 161.243 119.828C159.585 122.643 155.428 123.84 152.484 122.349C149.396 120.763 148.109 116.478 149.807 113.346Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M162.225 73.4131C159.141 71.6323 157.995 67.3298 159.803 64.3492C161.589 61.3885 166.123 60.299 168.991 62.1306C171.819 63.9385 172.816 67.9471 171.183 70.9084C169.397 74.1542 165.424 75.2603 162.225 73.4131Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M99.3313 182.082C96.2273 180.202 95.1706 175.973 97.0662 173.032C98.8905 170.214 102.903 169.229 105.843 170.861C109.03 172.635 110.128 176.658 108.292 179.82C106.443 183.041 102.542 184.024 99.3313 182.082Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M122.66 97.6068C124.459 94.3575 128.424 93.2467 131.615 95.0892C134.691 96.8652 135.837 101.168 134.032 104.161C132.344 106.97 128.177 108.129 125.26 106.609C122.152 105.001 120.919 100.736 122.66 97.6068Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M150.879 30.6285C147.772 28.9442 146.501 24.6682 148.212 21.6094C149.895 18.6 154.363 17.3959 157.342 19.1491C160.202 20.8441 161.338 24.878 159.797 27.8704C158.117 31.1225 154.09 32.3616 150.879 30.6285Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M135.074 57.7379C131.972 55.9688 130.799 51.6944 132.584 48.6784C134.346 45.7034 138.872 44.588 141.758 46.4079C144.592 48.1864 145.626 52.2269 144.027 55.1861C142.271 58.4167 138.28 59.5557 135.074 57.7379Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M128.198 82.6213C126.293 85.7876 122.3 86.7394 119.137 84.7709C116.266 82.9817 115.184 78.968 116.777 76.0383C118.412 73.0345 122.904 71.7893 125.885 73.5213C128.936 75.2831 130.023 79.5736 128.198 82.6213Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M132.517 12.3618C130.757 15.524 126.643 16.6472 123.506 14.825C120.443 13.0455 119.311 8.71823 121.133 5.73415C122.855 2.9228 126.995 1.79266 129.915 3.32532C132.989 4.93524 134.234 9.27357 132.517 12.3618Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M142.088 170.5C139.063 168.578 138.105 164.253 140.081 161.402C141.986 158.652 146.067 157.719 148.928 159.392C151.979 161.175 152.978 165.371 151.094 168.462C149.164 171.636 145.264 172.521 142.088 170.5Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M178.483 183.803C176.706 187.109 172.88 188.246 169.632 186.425C166.508 184.676 165.305 180.472 167.069 177.455C168.738 174.602 172.761 173.427 175.761 174.917C178.93 176.495 180.188 180.621 178.483 183.803Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M215.739 187.427C217.509 184.38 221.803 183.306 224.828 185.151C227.685 186.888 228.812 190.939 227.241 193.87C225.602 196.937 221.236 198.211 218.197 196.523C215.166 194.839 213.983 190.449 215.739 187.427Z",
    fill: "#8F1C26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_496_49855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248.843,
    height: 248.748,
    fill: "white",
    transform: "translate(339.844 124.374) rotate(120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFrame2);
export default __webpack_public_path__ + "static/media/footer-frame2.afb790f21930be227c74237b55772664.svg";
export { ForwardRef as ReactComponent };